class ProviderCommon {
  constructor() {}

  getConsentReducerFromSettings(settings = { actionType: 'optout' }) {
    switch (settings.actionType) {
      case 'optin':
        return () => true;
      case 'neutral':
        return () => null;
      default:
      case 'optout':
        return () => false;
    }
  }
}

export const providerCommon = new ProviderCommon();
